export const DETAIL_FORM_UNIFORM_FIELDS_SX = {
  '& .MuiOutlinedInput-root:not(.MuiInputBase-multiline)': {
    minHeight: 52,
    alignItems: 'center',
  },
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
  },
};
